import createIcon from "../icons/createKanbanIcon.svg"
import bsEmptyIcon from "../icons/bs-is-empty.svg"
import bsDoneIcon from "../icons/bs-is-done.svg"
import searchIcon from "../../../assets/images/icons/search.svg"
import React, {useContext, useEffect, useRef, useState} from "react";
import {MainContextProvider} from "../../../context/MainContext";
import "./business_goals_kanban.scss"
import customAxios from "../../../service/api/interceptors";
import {CompanyType} from "../../../types/company.type";
import ModalContainer from "../../../components/ModalContainer";
import {CreateBusinessGoal} from "../modals/CreateBusinessGoal/CreateBusinessGoal";
import {useHistory, useLocation} from "react-router-dom";
import {BusinessGoalType} from "../BusinessGoal.type";
import {CustomLoader} from "../../../components/UI/CustomLoader/CustomLoader";
import {ProjectSuggestionsType} from "../ProjectSuggestions.type";
import {useOnClickOutside} from "../../../hooks/useOnClickOutside";
import filterIcon from "../../../assets/images/filter.svg";
import {CSSTransition} from "react-transition-group";
import {Input} from "../../../components/UI";
import moment from "moment";
import {
    ClientsSearchDropdown,
    getCompanyStatus
} from "../../../components/other/ClientsSearchDropdown/ClientsSearchDropdown";
import axios from "axios";
import {FrozenController} from "../../../components/other/FrozenController/FrozenController";
import {TabSubscriptionInfo} from "../../LegalManager/ManagerKanban/TabSubscriptionInfo";

type clientSubscriptionType = {
    title: string
    activate_date: string
    active: string
}

export const BusinessGoalsVloKanban: React.FC = () => {
    const { setLoading, userData, setCurrentTimer } = useContext(MainContextProvider)
    const [companies, setCompanies] = useState<CompanyType[]>([])
    const [companyId, setCompanyId] = useState<null | string>(null)
    const [localLoading, setLocalLoading] = useState(true)
    const [items, setItems] = useState<BusinessGoalType[]>([])
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [clientSubscription, setClientSubscription] = useState<clientSubscriptionType>({} as clientSubscriptionType)
    const history = useHistory()
    const location = useLocation()
    const searchParams = new URLSearchParams(location.search);

    const getClientSubscriptionData = async () => {
        const { status, data } = await customAxios.get(`/company/${searchParams.get('client') || companies[0].id}/subscription`)
        if (status === 200) {
            setClientSubscription(data)
        }
    }

    useEffect(() => {
        if (companies.length === 0) {
            return
        }
        getClientSubscriptionData().then()
    }, [companies, searchParams.get('client')])

    const getAllItems = async () => {
        setLocalLoading(true)
        try {
            const { status, data } = await customAxios.get(`/company/${searchParams.get('client') || companies[0].id}/business-goals`)
            if (status === 200) {
                setItems(data)
            }
        } catch (e) {}
        setLocalLoading(false)
    }

    const getClients = async () => {
        try {
            const { status, data } = await customAxios.get(`/company/company/get-companies?expand=client,company&per-page=500&is_credit_count=1`)
            if (status === 200) {
                setCompanies([
                    ...data.filter((el: CompanyType) => el.debt !== 'unsubscribed'),
                    ...data.filter((el: CompanyType) => el.debt === 'unsubscribed'),
                ])

                if (!searchParams.get('client')) history.push(`/legal-projects?client=${data.filter((el: CompanyType) => el.debt !== 'unsubscribed')[0]?.id}`)
            }
        } catch (e) {}
    }

    useEffect(() => {
        setLoading(false)
        if (searchParams.get('client')) {
            getAllItems().then()
        }

        document.title = 'Projects'
        setCurrentTimer('redirect')
    }, [location, searchParams.get('client')])

    useEffect(() => {
        if (companies.length === 0) {
            getClients().then()
        }
    }, [])

    const getPriority = (priority: number) => {
        switch (priority) {
            case 1: return { value: 1, label: 'Low', color: '#000' }
            case 2: return { value: 2, label: 'Medium', color: '#FF9E45' }
            case 3: return { value: 3, label: 'High', color: '#F00' }
            default: return { value: '', label: 'Not Selected', color: '#ad5700' }
        }
    }
    
    const GetProgressBarData = ({ items }: { items: ProjectSuggestionsType[] }): any => {
        const width = 100 / items.length
        const obj: { [key: string]: {}[] } = { green: [], blue: [], grey: [] }
        items.map(el => {
            if (+el.is_done === 1) {
                obj.green.push({})
            } else if (!!el.offer && !Array.isArray(el.offer)) {
                obj.blue.push({})
            } else {
                obj.grey.push({})
            }
        })

        return <>
            {obj.green.length > 0 && obj.green.map(() => <div style={{background: '#57AC15', width: `${width}%`}}/>)}
            {obj.blue.length > 0 &&  obj.blue.map(() => <div style={{background: '#2361FF', width: `${width}%`}}/>)}
            {obj.grey.length > 0 && obj.grey.map(() => <div style={{background: '#F3F5FA', width: `${width}%`}}/>)}
            {
                items.length === 0 && <div style={{background: '#F3F5FA', width: `100%`}}/>
            }
        </>
    }

    const ProjectSuggestionsInCard: React.FC<{ items: ProjectSuggestionsType[] }> = ({ items }) => {
        const inProgressItems = items.filter(el => !!el.offer && !Array.isArray(el.offer) && +el.is_done !== 1)
        const isDoneItems = items.filter(el => +el.is_done === 1)
        //if (inProgressItems )

        if (items.length === 1) {
            console.log(items)
        }

        if ((items.length === isDoneItems.length) && items.length > 0) {
            return (
                <div className={'business_goals_kanban__bs-with-image flex-center'}>
                    <div className={'flex-center'}>
                        <img src={bsDoneIcon} alt=""/>
                        <p>
                            All works have <br />
                            been done
                        </p>
                    </div>
                </div>
            )
        }

        if (inProgressItems.length === 0) {
            return (
                <div className={'business_goals_kanban__bs-with-image flex-center'}>
                    <div className={'flex-center'}>
                        <img src={bsEmptyIcon} alt=""/>
                        {/*<p>
                            There are currently no Works in progress, please SELECT Works To get started
                        </p>*/}
                        <p>
                            NO TASKS IN PROGRESS. PLEASE SELECT TASKS TO GET STARTED.
                        </p>
                    </div>
                </div>
            )
        }

        if (inProgressItems.length > 0) {
            return (
                <div className={'business_goals_kanban__bs-items'}>
                    {
                        (inProgressItems || []).map((el, index) => {
                            if (index <= 1) {
                                return (
                                    <div className="business_goals_kanban__bs-item">
                                        <div>
                                            {el.title.length > 110 ? `${el.title.substr(0, 110)}...` : el.title}
                                        </div>
                                        <div style={{width: '5px', marginLeft: '5px'}}>
                                            <div className="business_goals_kanban__bs-item-circle"/>
                                        </div>
                                    </div>
                                )
                            }
                        })
                    }

                    {inProgressItems.length > 2 && <em>+{inProgressItems.length - 2} MORE TASKS</em>}
                </div>
            )
        }

        return <></>
    }
    
    const CardItemBsText: React.FC<{ items: ProjectSuggestionsType[] }> = ({ items }) => {
        const length = items.length
        const inProgressItems = items.filter(el => !!el.offer && !Array.isArray(el.offer) && +el.is_done !== 1)
        const isDoneItems = items.filter(el => +el.is_done === 1)

        return <>
            <div className={'flex-center'}>
                <div className="business_goals_kanban__item-progress-text-circle" style={{ background: '#57AC15' }} />
                Done ({isDoneItems.length}/{length})
            </div>
            {(isDoneItems.length > 0 && isDoneItems.length === length) ? <></> : <div className={'flex-center'} style={{marginLeft: '15px'}}>
                <div className="business_goals_kanban__item-progress-text-circle" style={{background: '#2361ff'}}/>
                In Progress ({inProgressItems.length}/{length})
            </div>}
        </>
    }

    if (localLoading || companies.length === 0) {
        return <CustomLoader />
    }

    return (
        <div className={'business_goals_kanban'}>
            {searchParams.get('company') && <FrozenController debt={companies.find(el => String(el.id) === searchParams.get('company'))?.debt || 'none'}/>}
            <div className={'business_goals_kanban__header'}>
                <h2>Projects</h2>
                <div>
                    {companies.length > 0 && <div className={'w100'} style={{ background: '#FFF', padding: '10px', borderRadius: '10px', marginTop: '10px' }}>
                        <div className={'flex alignCenter'}>
                            <div style={{ maxWidth: '350px' }}>
                                <ClientsSearchDropdown
                                    onClick={(key) => {
                                        history.push(`/legal-projects?client=${key}`)
                                    }}
                                    value={searchParams.get('client') || companies[0].id + ''}
                                    arr={companies.map(el => ({ ...el, value: String(el.id), label: el.name}))}
                                />
                            </div>
                            {(searchParams.get('client') || companies[0].id) && userData?.status.type_code !== 100 && <TabSubscriptionInfo
                                clients={companies}
                                searchParams={searchParams}
                            />}
                            {/*{
                                (searchParams.get('company') || companies[0].id) && userData?.status.type_code !== 100 && <div
                                    style={{
                                        color: getCompanyStatus(companies.find(el => String(el.id) === (searchParams.get('company') || String(companies[0].id)))?.debt || '').color,
                                        background: getCompanyStatus(companies.find(el => String(el.id) === (searchParams.get('company') || String(companies[0].id)))?.debt || '').background,
                                        borderRadius: '20px',
                                        padding: '8px 18px',
                                        marginLeft: '15px',
                                        fontSize: '13px',
                                        textTransform: 'uppercase'
                                    }}>{getCompanyStatus(companies.find(el => String(el.id) === (searchParams.get('company') || String(companies[0].id)))?.debt || '').label}</div>
                            }
                            {clientSubscription?.activate_date && userData?.status.type_code !== 100 && <div>
                                <span style={{
                                    fontSize: '12px',
                                    fontFamily: 'Inter',
                                    marginLeft: '15px'
                                }}>{clientSubscription?.title}</span>
                                <em style={{fontSize: '12px', fontFamily: 'Inter', marginLeft: '15px'}}>Start
                                    on: {moment(new Date(+clientSubscription?.activate_date * 1000)).format('DD-MM-YYYY')}</em>
                            </div>}*/}
                        </div>
                    </div>}
                </div>
            </div>
            <div className="business_goals_kanban__body">
                <div className="business_goals_kanban__body-items">
                    {(userData?.status.type_code === 300 || userData?.status.type_code === 400) && <div onClick={() => setIsModalOpen(true)} className="business_goals_kanban__create-button">
                        <div>
                            <img src={createIcon} alt=""/>
                            <span>Create Legal Project</span>
                        </div>
                    </div>}
                    {
                        (items || []).map(item => (
                            <div className="business_goals_kanban__item">
                                <div className="business_goals_kanban__item-heading">
                                    {item.title} {+item.stage === 2 && `(Draft)`}
                                </div>
                                <div className="business_goals_kanban__item-body">
                                    <div className="business_goals_kanban__item-priority">
                                        <span>Priority: <b style={{ color: getPriority(+item.priority).color }}>{getPriority(+item.priority).label}</b></span>
                                        <span className={"ml15"}>Status: <b>{String(item.status) === "1" ? "Completed" : "Active"}</b></span>
                                    </div>
                                    <div className={'business_goals_kanban__item-progress-text'}>
                                        <CardItemBsText items={item.project_suggestions} />
                                    </div>
                                    <div className={'business_goals_kanban__item-progress-line'}>
                                        <GetProgressBarData items={item.project_suggestions} />
                                    </div>
                                    <div className="business_goals_kanban__item-important">
                                        TASKS IN PROGRESS ({(item.project_suggestions || []).filter(el => !!el.offer && !Array.isArray(el.offer) && +el.is_done !== 1).length})
                                    </div>
                                    <ProjectSuggestionsInCard items={item.project_suggestions} />
                                </div>
                                <div
                                    onClick={() => history.push(`/legal-projects/${item.id}`)}
                                    className="business_goals_kanban__item-button">
                                    <button>View</button>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>

            <CreateBusinessGoal
                isOpen={isModalOpen}
                updateItems={getAllItems}
                close={() => setIsModalOpen(false)}
                company_id={searchParams.get('client') || companies[0].id}
            />
        </div>
    )
}